export default "<div [ngStyle]=\"GetColor(id)\">{{ GetDegatsType(id) }}</div>";